<ion-content [fullscreen]="true">
	<div class="di-suivi-facturation">
		<ng-container *ngIf="!isMobileView">
			<div class="menu-mois-container">
				<h1>Suivi facturation</h1>
				<div class="menu-facture-preparee">
					<di-separateur-date date="EN ATTENTE DE FACTURATION"></di-separateur-date>
					<di-btn-facture-preparee (click)="afficherFacturesPreparees()" [invoiceCount]="nbPreparedInvoice" [selected]="showPreparedInvoice"></di-btn-facture-preparee>
				</div>
				<di-menu-mois [monthSelected]="!showPreparedInvoice" [onMonthSelected]="initListeFactures"></di-menu-mois>
			</div>
		</ng-container>
		<main *ngIf="showPreparedInvoice" class="facturation-content">
			<di-factures-preparees [openPanneauFactureMois]="openPanneauFactureMois"></di-factures-preparees>
		</main>
		<main *ngIf="!showPreparedInvoice" class="facturation-content">
			<header class="facturation-header">
				<div class="titre">
					<div class="soustitre">
						<h1>{{ dateMonthDisplayed | firstUpperCase }}</h1>
						<small>{{libelleNbInvoices}} - {{montantTotalInvoice | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr-FR' }}</small>
					</div>
					<ng-container *ngIf="isMobileView">
						<lua-bouton-icone (onClick)="openPanneauFactureMois()" iconName="menu" mode="outlined"></lua-bouton-icone>
					</ng-container>
				</div>
				<div class="filters">
					<lua-filtres
						[fullWidth]="isMobileView" 
						class="filtre-infirmiers" 
						[selectedFilters]="filterInfirmiersSelected" 
						(click)="openMenuFiltreInfirmier($event)" 
						label="Infirmier">
					</lua-filtres>
					<lua-filtres *ngIf="!isMobileView"  [selectedFilters]="filterAMOSelected" (click)="openMenuFiltreAmo($event)" label="Sécurité sociale"></lua-filtres>
					<lua-filtres *ngIf="!isMobileView"  [selectedFilters]="filterAMCSelected" (click)="openMenuFiltreAmc($event)" label="Mutuelle"></lua-filtres>
					<lua-filtres *ngIf="!isMobileView"  [selectedFilters]="filterPPSelected" (click)="openMenuFiltrePartPatient($event)" label="Part patient"></lua-filtres>
					<lua-recherche 
						[fullWidth]="isMobileView" 
						iconeDefault="search" 
						[secondaryAction]="false"
						 [searchText]="searchedValue"
						(onValueChange)="searchInvoicesByTerm($event)">
					</lua-recherche>
				</div>
			</header>
	
			<section class="facture-list">
				<ng-container *ngIf="filteredInvoices && filteredInvoices.length > 0">
					<ng-container *ngFor="let item of filteredInvoices">
						<di-carte-facturation [invoice]="item"></di-carte-facturation>
					</ng-container>
				</ng-container>
				<ng-container *ngIf="!filteredInvoices || filteredInvoices.length === 0">
					<lua-message-aucune-donnee
						[mainText]="mainTextAucuneFacture"
						[subText]="subTextAucuneFacture"
						isIcon="true" 
						customIconName="invoice-euro">
					</lua-message-aucune-donnee>
				</ng-container>
			</section>
		</main>
	</div>
</ion-content>